document.addEventListener('DOMContentLoaded', function() {
    console.log('variants-add-button.js loaded');

    // Rimuovi la condizione e aggiungi sempre il listener
    document.addEventListener('click', function(e) {
        console.log('Click event detected:', e.target);
        if (e.target.classList.contains('variant-upsell-button-drawer')) {
            console.log('variant-upsell-button-drawer clicked');
            const button = e.target;
            const variantId = button.dataset.variantId;

            button.classList.add('loading');
            button.disabled = true;

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({id: variantId, quantity: 1})
            })
                .then(response => response.json())
                .then(() => {
                    const cartDrawerItems = document.querySelector('cart-drawer-items');
                    if (cartDrawerItems) {
                        cartDrawerItems.onCartUpdate();
                    }
                })
                .catch(error => console.error('Error:', error))
                .finally(() => {
                    button.classList.remove('loading');
                    button.disabled = false;
                });
        }
    });
});